import { Injectable } from '@angular/core';
import { TaxwdServicePkg } from './taxwdPkg.service';

@Injectable({
  providedIn: 'root',
})
export class TaxwdService extends TaxwdServicePkg {
  constructor() {
    super();
  }
}
